<template>
  <SignupFieldComponent
    :field
    :value="model"
    :rules
    v-slot="{ id, invalid, touch }"
  >
    <NumberInput :id v-model="model" :invalid @blur="touch" />
  </SignupFieldComponent>
</template>

<script setup lang="ts">
import type { ValidationRuleCollection } from "@vuelidate/core";
import type { GeneratorReviewKey } from "./fieldKeys";
import NumberInput from "./NumberInput.vue";
import SignupFieldComponent from "./SignupFieldComponent.vue";

withDefaults(
  defineProps<{
    field: GeneratorReviewKey;
    rules?: ValidationRuleCollection;
  }>(),
  { rules: () => ({}) }
);

const model = defineModel<number | null>({ default: null });
</script>
